import { normalizeLocationInfo } from '@utils/storeDataNormalization';
import citiesModuleFactory from '@helpers/storeFactories/moduleFactory';
import { apiService } from '@api';
import citiesWithHotels from './citiesWithHotels';

const STORE_NAME = 'cities';

const store = citiesModuleFactory.createModuleView(
    STORE_NAME,
    apiService,
    { customListFormatter: normalizeLocationInfo },
    {
        modules: {
            citiesWithHotels: citiesWithHotels,
        },
    }
);

export default store;
